import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import About from './components/About';
import Time from './components/Time';
import Services from './components/Services';
import Contact from './components/Contact';
import Carousel from './components/Carousel';
import Login from './components/Login';
import Footer from './components/Footer'
import NotFound from './components/NotFound';

const Home = ({ scrollTo }) => {
  return (
    <>
      <Navbar scrollTo={scrollTo} />
      <div className='content-offset'>
        <Carousel />

        <div className='background-fixed' style={{
          background: `url(${process.env.PUBLIC_URL}/logo_sanistar-removebg-preview.png)`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          width: '100%',
          height: '100vh'
        }}>
        </div>

        <div>
          <Gallery />
          <div className="container d-flex flex-column flex-md-row justify-content-center align-items-start mb-4">
            <div className="mb-4 mb-md-0" style={{ flex: 1 }}>
              <About />
            </div>
            <div className="w-100 w-md-50 mx-md-0 mx-auto" style={{ maxWidth: '300px' }}>
              <Time />
            </div>
          </div>
          <Services />
          <Contact />
        </div>
        <Footer scrollTo={scrollTo} />
        <div className='position-fixed d-flex justify-content-center align-items-center opacity-85 animated-button'
          style={{
            width: "60px",
            height: "60px",
            background: '#28A629',
            borderRadius: "50%",
            right: "20px",
            bottom: "20px",
            zIndex: 9999
          }}>
          <a href='https://wa.link/jgqd57' target='_blank' style={{ fontSize: '30px' }}>
            <i className='fa-brands fa-whatsapp text-white'></i>
          </a>
        </div>
      </div>
    </>
  )
}

class App extends React.Component {
  scrollTo = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  render() {
    return (
      <div>
        <Router>

          <Routes>
            <Route path="/" element={<Home scrollTo={this.scrollTo} />} />
            <Route path="/admin-login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </div>
    );
  }
}

export default App;